import imagePath from '@/javascript/imagePath.js';
import { imageNames } from '@/javascript/imageConstants.js';

export const themeIconMap = {
  [imageNames.BOLT_ICON]: {
    darkIcon: imagePath.boltIcon,
    lightIcon: imagePath.boltIcon,
  },
  [imageNames.INFO_ICON]: {
    darkIcon: imagePath.infoIcon,
    lightIcon: imagePath.infoIcon,
  },
  [imageNames.DISCOUNT_ICON]: {
    darkIcon: imagePath.discountIcon,
    lightIcon: imagePath.discountIcon,
  },
  [imageNames.LOGOUT_ICON]: {
    darkIcon: imagePath.logoutIcon,
    lightIcon: imagePath.logoutIcon,
  },
  [imageNames.ONLINE_NAV_ICON]: {
    darkIcon: imagePath.onlineNavIcon,
    lightIcon: imagePath.onlineNavIcon,
  },
  [imageNames.SUPER_AGI_ICON]: {
    darkIcon: imagePath.superAgiIcon,
    lightIcon: imagePath.superAgiIcon,
  },
  [imageNames.DISCORD_ICON]: {
    darkIcon: imagePath.discordIcon,
    lightIcon: imagePath.discordIcon,
  },
  [imageNames.SUPER_AGI_TEXT]: {
    darkIcon: imagePath.superAgiText,
    lightIcon: imagePath.superAgiText,
  },
  [imageNames.MANAGE_BILLING]: {
    darkIcon: imagePath.manage_billing,
    lightIcon: imagePath.manage_billing,
  },
  [imageNames.SELECTED_MANAGE_BILLING]: {
    darkIcon: imagePath.selected_manage_billing,
    lightIcon: imagePath.selected_manage_billing,
  },
  [imageNames.SOFTWARE_CREDITS]: {
    darkIcon: imagePath.software_credits,
    lightIcon: imagePath.software_credits,
  },
  [imageNames.SELECTED_SOFTWARE_CREDITS]: {
    darkIcon: imagePath.selected_software_credits,
    lightIcon: imagePath.selected_software_credits,
  },
  [imageNames.PAYMENT_METHODS]: {
    darkIcon: imagePath.payment_methods,
    lightIcon: imagePath.payment_methods,
  },
  [imageNames.INVOICES]: {
    darkIcon: imagePath.invoices,
    lightIcon: imagePath.invoices,
  },
  [imageNames.SELECTED_INVOICES]: {
    darkIcon: imagePath.selected_invoices,
    lightIcon: imagePath.selected_invoices,
  },
  [imageNames.WORKER_ACTIVITY]: {
    darkIcon: imagePath.worker_activity,
    lightIcon: imagePath.worker_activity,
  },
  [imageNames.SELECTED_WORKER_ACTIVITY]: {
    darkIcon: imagePath.selected_worker_activity,
    lightIcon: imagePath.selected_worker_activity,
  },
  [imageNames.OPEN_IN_NEW]: {
    darkIcon: imagePath.open_in_new,
    lightIcon: imagePath.open_in_new,
  },
  [imageNames.SORTING_ARROW]: {
    darkIcon: imagePath.sortingArrow,
    lightIcon: imagePath.sortingArrow,
  },
  [imageNames.SORTING_ARROW_SELECTED]: {
    darkIcon: imagePath.sortingArrowSelected,
    lightIcon: imagePath.sortingArrowSelected,
  },
  [imageNames.LEFT_ARROW_ICON]: {
    darkIcon: imagePath.leftArrowIcon,
    lightIcon: imagePath.leftArrowIcon,
  },
  [imageNames.RIGHT_ARROW_ICON]: {
    darkIcon: imagePath.rightArrowIcon,
    lightIcon: imagePath.rightArrowIcon,
  },
  [imageNames.VERIFIED]: {
    darkIcon: imagePath.verified,
    lightIcon: imagePath.verified,
  },
  [imageNames.MORE_ICON_VERTICAL_DISABLED]: {
    darkIcon: imagePath.moreIconVerticalDisabled,
    lightIcon: imagePath.moreIconVerticalDisabled,
  },
  [imageNames.MORE_ICON_VERTICAL]: {
    darkIcon: imagePath.moreIconVertical,
    lightIcon: imagePath.moreIconVertical,
  },
  [imageNames.STATUS_BULLET]: {
    darkIcon: imagePath.statusBullet,
    lightIcon: imagePath.statusBullet,
  },
  [imageNames.CLOSE_ICON]: {
    darkIcon: imagePath.closeIcon,
    lightIcon: imagePath.closeIcon,
  },
  [imageNames.WHITE_DOT]: {
    darkIcon: imagePath.whiteDot,
    lightIcon: imagePath.whiteDot,
  },
  [imageNames.ARROW_DOWN_TOOLTIP]: {
    darkIcon: imagePath.arrowDownTooltip,
    lightIcon: imagePath.arrowDownTooltip,
  },
  [imageNames.PROFILE_ICON_PLACEHOLDER]: {
    darkIcon: imagePath.profileIconPlaceholder,
    lightIcon: imagePath.profileIconPlaceholder,
  },
  [imageNames.PRODUCTS_ADMIN]: {
    darkIcon: imagePath.products_admin,
    lightIcon: imagePath.products_admin,
  },
  [imageNames.SELECTED_PRODUCTS_ADMIN]: {
    darkIcon: imagePath.selected_products_admin,
    lightIcon: imagePath.selected_products_admin,
  },
  [imageNames.EMPTY_SCREEN]: {
    darkIcon: imagePath.emptyScreen,
    lightIcon: imagePath.emptyScreen,
  },
  [imageNames.DOWNLOAD_ICON]: {
    darkIcon: imagePath.downloadIcon,
    lightIcon: imagePath.downloadIcon,
  },
  [imageNames.REMOVE_ICON]: {
    darkIcon: imagePath.removeIcon,
    lightIcon: imagePath.removeIcon,
  },
  [imageNames.CHECK]: {
    darkIcon: imagePath.check,
    lightIcon: imagePath.check,
  },
  [imageNames.WORKSPACE_FILLED]: {
    darkIcon: imagePath.workspaceFilled,
    lightIcon: imagePath.workspaceFilled,
  },
  [imageNames.WORKSPACE_EMPTY]: {
    darkIcon: imagePath.workspaceEmpty,
    lightIcon: imagePath.workspaceEmpty,
  },
  [imageNames.ADD_ICON]: {
    darkIcon: imagePath.addIcon,
    lightIcon: imagePath.addIcon,
  },
  [imageNames.PREVIEW_ICON]: {
    darkIcon: imagePath.previewIcon,
    lightIcon: imagePath.previewIcon,
  },
  [imageNames.COIN_ICON]: {
    darkIcon: imagePath.coinIcon,
    lightIcon: imagePath.coinIcon,
  },
  [imageNames.MINUS_ICON]: {
    darkIcon: imagePath.minusIcon,
    lightIcon: imagePath.minusIcon,
  },
  [imageNames.GREY_TICK_CIRCLE]: {
    darkIcon: imagePath.greyTickCircle,
    lightIcon: imagePath.greyTickCircle,
  },
  [imageNames.GREEN_TICK_CIRCLE]: {
    darkIcon: imagePath.greenTickCircle,
    lightIcon: imagePath.greenTickCircle,
  },
  [imageNames.DOWN_ARROW_BLACK_ICON]: {
    darkIcon: imagePath.downArrowBlackIcon,
    lightIcon: imagePath.downArrowBlackIcon,
  },
  [imageNames.CANCEL_GREY_CIRCLE_ICON]: {
    darkIcon: imagePath.cancelGreyCircleIcon,
    lightIcon: imagePath.cancelGreyCircleIcon,
  },
  [imageNames.EMAIL_PINK_ICON]: {
    darkIcon: imagePath.emailPinkIcon,
    lightIcon: imagePath.emailPinkIcon,
  },
  [imageNames.PHONE_PINK_ICON]: {
    darkIcon: imagePath.phonePinkIcon,
    lightIcon: imagePath.phonePinkIcon,
  },
  [imageNames.MARKET_RESEARCH_PINK_ICON]: {
    darkIcon: imagePath.marketResearchPinkIcon,
    lightIcon: imagePath.marketResearchPinkIcon,
  },
  [imageNames.SIGNAL_PINK_ICON]: {
    darkIcon: imagePath.signalPinkIcon,
    lightIcon: imagePath.signalPinkIcon,
  },
  [imageNames.POKER_PINK_ICON]: {
    darkIcon: imagePath.pokerPinkIcon,
    lightIcon: imagePath.pokerPinkIcon,
  },
  [imageNames.DRAG_ICON_GREY]: {
    darkIcon: imagePath.dragIconGrey,
    lightIcon: imagePath.dragIconGrey,
  },
  [imageNames.QUESTION_MARK]: {
    darkIcon: imagePath.questionMark,
    lightIcon: imagePath.questionMark,
  },
  [imageNames.CLOCK_ICON]: {
    darkIcon: imagePath.clockIcon,
    lightIcon: imagePath.clockIcon,
  },
  [imageNames.LOCK_ICON]: {
    darkIcon: imagePath.lockIcon,
    lightIcon: imagePath.lockIcon,
  },
  [imageNames.WARNING_ICON]: {
    darkIcon: imagePath.warningIcon,
    lightIcon: imagePath.warningIcon,
  },
  [imageNames.VISA_ICON]: {
    darkIcon: imagePath.visaIcon,
    lightIcon: imagePath.visaIcon,
  },
  [imageNames.MASTERCARD_ICON]: {
    darkIcon: imagePath.mastercardIcon,
    lightIcon: imagePath.mastercardIcon,
  },
  [imageNames.AMEX_ICON]: {
    darkIcon: imagePath.amexIcon,
    lightIcon: imagePath.amexIcon,
  },
  [imageNames.DISCOVER_ICON]: {
    darkIcon: imagePath.discoverIcon,
    lightIcon: imagePath.discoverIcon,
  },
  [imageNames.UNKNOWN_ICON]: {
    darkIcon: imagePath.unknownIcon,
    lightIcon: imagePath.unknownIcon,
  },
};
